import bboxPolygon from '@turf/bbox-polygon';
import mapPromiseMixin from '@/mixins/map';
import within from '@turf/boolean-within';

export default {
    mixins: [
        mapPromiseMixin,
    ],
    methods: {
        /**
         * move the map to focus on the selected feature
         * @param  {Object} feature feature object with coords
         */
        revealFeature(feature) {
            if (!this.map) {
                return;
            }

            const newPosition = {};

            // move the map if the feature is outside be viewport
            const bbox = this.$store.state.map.bbox;
            const [lng, lat] = feature.coords;
            const featureGeojson = {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'Point',
                    coordinates: [
                        lng,
                        lat,
                    ],
                },
            };
            const mapBounds = bboxPolygon(bbox);
            // zoom in if the zoom is < 11
            const currentZoom = this.map.getZoom();
            if (currentZoom < 11 || !within(featureGeojson, mapBounds)) {
                newPosition.center = feature.coords;
                newPosition.zoom = (currentZoom < 11) ? 11 : currentZoom;
            }

            this.map.flyTo(newPosition);
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/revealFeature.js